import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  expansionPanel: {
    margin: `0 0 ${theme.spacing(2.5)}`,
    backgroundColor: '#f6f6f8',
    fontSize: 15,
    fontWeight: 900,
    color: '#3e424e',
    alignItems: 'center',
    minHeight: 0,
  },
  expansionPanelExpanded: {
    margin: theme.spacing(2.5),
    backgroundColor: 'white',
  },
  accordionSummary: {
    padding: theme.spacing(2),
  },
  accordionExpanded: {
    backgroundColor: '#f6f6f8',
    minHeight: 0,
  },
  accordionSummaryRoot: {
    height: 46,
    minHeight: 0,
    display: 'flex',
    padding: '0 10px 0 0',
  },
  accordionSummaryContent: {
    fontSize: 15,
    fontWeight: 900,
    textAlign: 'left',
    color: '#3e424e',
  },
  accordionDetails: {
    maxHeight: 220,
    overflow: 'auto',
  },
}));
